import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/bancos/1touchpay`;

// Sólo estados visibles PENDIENTE. Lee Mongo, jamás consulta al proveedor desde el navegador.
export const useLedgerPendingStates = (items, key, cvu, setSnapshot, setError) => {
  const ids = (items || []).filter(m => m.estado === 'PENDIENTE').map(m => m.otp_id).join(',');
  useEffect(() => {
    if (!ids) return;
    let active = true;
    let running = false;
    let abort;
    const read = async () => {
      if (!active || running || document.visibilityState !== 'visible') return;
      running = true;
      abort = new AbortController();
      try {
        const { data } = await axios.get(`${API}/ledger/estados`, {
          params: { ids, ...(cvu ? { cvu_id: cvu } : {}) }, signal: abort.signal, timeout: 8000,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (!active || abort.signal.aborted) return;
        const byId = new Map((data.items || []).filter(m => !cvu || String(m.cvu_id) === String(cvu)).map(m => [String(m.otp_id), m]));
        setSnapshot(previous => previous?.key === key ? { key, data: { ...previous.data,
          items: previous.data.items.map(m => m.estado === 'PENDIENTE' && byId.has(String(m.otp_id))
            ? { ...m, ...byId.get(String(m.otp_id)) } : m),
        } } : previous);
        setError(previous => previous?.key === key && previous.kind === 'states' ? null : previous);
      } catch (e) {
        if (active && !abort.signal.aborted) setError({ key, kind: 'states', message: 'No se pudieron actualizar los estados pendientes. Podés refrescar el ledger.' });
      } finally {
        running = false;
      }
    };
    read();
    const timer = setInterval(read, 5000);
    document.addEventListener('visibilitychange', read);
    return () => { active = false; abort?.abort(); clearInterval(timer); document.removeEventListener('visibilitychange', read); };
  }, [ids, key, cvu, setSnapshot, setError]);
};